export default __webpack_public_path__ + "static/media/Simple-Line-Icons.85e8c542.eot";